(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !window.DesignMode) return;
  try {
    
  class FaqToggle extends HTMLElement {
    constructor() {
      super();

      this.headings = this.querySelectorAll('.faq-group-headings .faq-group-heading');
      this.contentGroups = this.querySelectorAll('.faq-group-contents .faq-group-content');
      
      this.mobileHeadings = this.querySelectorAll('.faq-group .faq-group-heading');
      this.mobileGroup = this.querySelectorAll('.faq-group');

      for (const heading of this.headings) {
        heading.addEventListener('click', (e) => {
          e.preventDefault();

          this.setActiveHeading(e.target);
          this.setActiveGroupContents(e.target.dataset.group);
        })
      }

      for (const heading of this.mobileHeadings) {
        heading.addEventListener('click', (e) => {
          e.preventDefault();

          this.setActiveMobileGroup(e.target.dataset.group);
        })
      }
    }

    setActiveHeading(target) {
      for ( let heading of this.headings ) {
        heading.classList.remove('active');
      }

      target.classList.add('active');
    }

    setActiveGroupContents(slug) {
      for ( let contentGroup of this.contentGroups ) {
        contentGroup.classList.remove('active');
      }

      this.querySelector(`.faq-group-contents .faq-group-content[data-group="${slug}"]`).classList.add('active');
    }

    setActiveMobileGroup(slug) {
      for ( let group of this.mobileGroup ) {
        group.classList.remove('active');
      }

      for ( let heading of this.mobileHeadings ) {
        console.log(heading.querySelector('span'))
        heading.querySelector('span').innerHTML = "&plus;";
      }

      this.querySelector(`.faq-group[data-group="${slug}"]`).classList.add('active');
      this.querySelector(`.faq-group[data-group="${slug}"] .faq-group-heading`).querySelector('span').innerHTML = "&dash;";
    }
  }

  customElements.define("faq-toggle", FaqToggle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.headerHover = this.querySelectorAll('.header');

      document.addEventListener('DOMContentLoaded', () => {
        const hoverIntentInstance = new SV.HoverIntent(this.headerHover, {
          onEnter: function(target) {
            target.classList.add('active');
          },
          onExit: function(target) {
            target.classList.remove('active');
          },
        });
      });
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.announcementBar = document.getElementById('shopify-section-announcement-bar');

      this.headerBounds = {};
      this.currentScrollTop = 0;


      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ( scrollTop > 0 ) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    reveal() {
      this.header.classList.add('sticky');
      this.announcementBar.classList.add('sticky');
    }

    reset() {
      this.header.classList.remove('sticky');
      this.announcementBar.classList.remove('sticky',);
    }
  }

  class MenuDropdown extends HTMLElement {
    constructor() {
      super();

      this.toggler = this.querySelectorAll('.header-menu__dropdown-toggler');

      document.addEventListener('DOMContentLoaded', () => {
        const hoverIntentInstance = new SV.HoverIntent(this.toggler, {
          onEnter: function(target) {
            target.querySelector('.header-menu__dropdown').classList.add('active');
          },
          onExit: function(target) {
            target.querySelector('.header-menu__dropdown').classList.remove('active');
          },
        });
      });
    }
  }

  customElements.define('menu-dropdown', MenuDropdown);
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  class BlogFilter extends HTMLElement {
    constructor() {
      super();

      this.form = document.getElementById('blog_filter_form');
      this.select = document.getElementById('blog_filter_select');
      this.select.addEventListener('change', this.onSelectChange.bind(this));
    }

    onSelectChange(event) {
      const value = event.target.value;
      let url = `${routes.blog_url}/tagged/${event.target.value}`

      if (value === '_') {
        url = routes.blog_url;
      }

      window.location.href = url;
    }
  }

  customElements.define('blog-filter', BlogFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class CollectionSort extends HTMLElement {
    constructor() {
      super();

      this.form = document.getElementById('collection_sort_form');
      this.select = document.getElementById('collection_sort_select');
      this.select.addEventListener('change', this.onSelectChange.bind(this));
    }

    onSelectChange(event) {
      this.form.submit();
    }
  }

  customElements.define('collection-sort', CollectionSort);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  customElements.define('product-modal', ProductModal);

  // class ProductMeta extends HTMLElement {
  //   constructor() {
  //     super();

  //     this.toggle = this.querySelector('.product-meta__toggle');
  //     this.main = this.querySelector('.product-meta__main');
  //     this.table = this.querySelector('.product-meta__table');
  //     this.open = true;

  //     if (this.toggle) this.toggle.addEventListener('click', this.handleToggle.bind(this));
  //   }

  //   handleToggle(e) {
  //     this.open ? this.handleClose() : this.handleOpen();
  //   }

  //   handleOpen() {
  //     this.main.classList.remove('open');
  //     this.table.classList.add('open');
  //     this.open = true;
  //     this.toggle.innerHTML = '&ndash; Show less'
  //   }

  //   handleClose() {
  //     this.main.classList.add('open');
  //     this.table.classList.remove('open');
  //     this.open = false;
  //     this.toggle.innerHTML = '&plus; View all'
  //   }


  // };
  // customElements.define('product-meta', ProductMeta);


  // document.addEventListener('DOMContentLoaded', () => {
  //   const inquireModal = document.querySelector('.inquire-form-modal')
  //   const inquireToggleButtons = document.querySelectorAll('.inquire-product-toggle');
  //   const modalBg = inquireModal.querySelector('.modal-bg');
  //   const closeButton = inquireModal.querySelector('.inquire-close');

  //   function handleClose(e) {
  //     e.preventDefault();
  //     inquireModal.classList.remove('open');
  //     document.querySelector('body').classList.remove('modal-open');
  //   }

  //   function handleOpen(e) {
  //     console.log('open');
  //     e.preventDefault();
  //     inquireModal.classList.add('open');
  //     document.querySelector('body').classList.add('modal-open');
  //   }

  //   inquireToggleButtons.forEach((button) => {
  //     button.addEventListener('click', handleOpen);
  //   });

  //   modalBg.addEventListener('click', handleClose);
  //   closeButton.addEventListener('click', handleClose);

  // });

  } catch(e) { console.error(e); }
})();
})();
